import { render, staticRenderFns } from "./CoverDetails.vue?vue&type=template&id=600af854&scoped=true"
import script from "./CoverDetails.vue?vue&type=script&lang=js"
export * from "./CoverDetails.vue?vue&type=script&lang=js"
import style0 from "./CoverDetails.vue?vue&type=style&index=0&id=600af854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600af854",
  null
  
)

export default component.exports